import React from 'react';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphCtaIconBlock = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const icon = entity.getIn(['field_icon', 0, 'entity', 'field_icon', 0, 'value'], '');

  return (
    <Container className="ParagraphCtaIconBlock">
      <div className="row">
        <div className="col-12 ParagraphCtaIconBlock__wrapper">
          <div className="ParagraphCtaIconBlock__title">
            <h2 className="asH3">{title}</h2>
          </div>
          <div className="ParagraphCtaIconBlock__icon">
            <i className={`icon icon-${icon}`} />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCtaIconBlock;
